/** Time period options for filtering date-ranged data */
export enum PeriodFilter {
  TODAY = 'today',
  LAST_WEEK = 'last_week',
  LAST_MONTH = 'last_month',
  CURRENT_WEEK = 'current_week',
  CURRENT_MONTH = 'current_month',
  LAST_3_MONTHS = 'last_3_months',
  LAST_6_MONTHS = 'last_6_months',
  LAST_YEAR = 'last_year',
  ALL = 'all',
}
